import { rem } from '@heathmont/moon-utils';
import styled, { css } from 'styled-components';
import type ArticleType from '~/client/components/Blog/shared/articles/BlogArticle/ArticleType';
import Img from '~/client/shared/images/Img';
import media from '~/client/shared/media';
import basicImageStyle from './basicImageStyle';
import smallImageStyle from './smallImageStyle';

const landscapeStyle = css`
  border-radius: 0 ${rem(4)} 0 0;
  float: left;
  width: ${rem(136)};
  height: ${rem(76)};
  ${media.desktopSmall} {
    height: ${rem(160)};
    width: calc(50% - ${rem(10)});
  }
`;

type LayoutProps = {
  type?: 'article_container';
  size?: 'big' | 'small';
  container?: ArticleType;
};

const ArticleImage = styled(Img)((props: LayoutProps) => [
  basicImageStyle,
  props.size === 'small' && smallImageStyle,
  props.container === 'landscape' && landscapeStyle,
]);

export default ArticleImage;
